<ng-container *ngIf="cadastro">
  <button class="ant-btn" *ngIf="mostrarBotaoImprimir" (click)="abrirImpressaoContrato()">Imprimir </button>

  <div #printContract id="print-contract" class="contrato_impressao">
    <table>
      <thead>
        <tr>
          <td>
            <div class="header-space">&nbsp;</div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="content" [ngSwitch]="versao">
              <usucampeao-contratos-v1 *ngSwitchCase="contratoVersao.V1" [cadastro]="cadastro"
                [proprietario]="proprietario" [conjuge]="conjuge" [imovel]="imovel" [tipo]="tipo"
                [isPrint]="true"></usucampeao-contratos-v1>

              <usucampeao-contratos-v2 *ngSwitchCase="contratoVersao.V2" [cadastro]="cadastro"
                [proprietario]="proprietario" [conjuge]="conjuge" [imovel]="imovel" [tipo]="tipo"
                [isPrint]="true"></usucampeao-contratos-v2>

              <usucampeao-contratos-v3 *ngSwitchCase="contratoVersao.V3" [cadastro]="cadastro"
                [proprietario]="proprietario" [conjuge]="conjuge" [imovel]="imovel" [tipo]="tipo"
                [isPrint]="true"></usucampeao-contratos-v3>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="footer-space">&nbsp;</div>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="header">
      <img src="/assets/images/logo.png" alt="UsuCampeão logo">
    </div>
    <div class="footer">
      <p>
        <b>Usucampeão São Paulo </b> - Rua Claudio Soares, 72, 6º andar, CJ 615, Pinheiros, CEP 05.422-030, São Paulo -
        SP <br>
        <b>Usucampeão Belo Horizonte</b> – Rua Jose Rodrigues Pereira, 514, 2˚ andar, CJ 201 – Estoril CEP 30455-640, BH
        - MG <br>
        www.usucampeao.com.br <br>
        e-mail: reurb&#64;usucampeao.com.br
      </p>
    </div>
  </div>

  <div [ngSwitch]="versao">
    <usucampeao-contratos-v1 *ngSwitchCase="contratoVersao.V1" [cadastro]="cadastro" [proprietario]="proprietario"
      [conjuge]="conjuge" [imovel]="imovel" [tipo]="tipo"></usucampeao-contratos-v1>

    <usucampeao-contratos-v2 *ngSwitchCase="contratoVersao.V2" [cadastro]="cadastro" [proprietario]="proprietario"
      [conjuge]="conjuge" [imovel]="imovel" [tipo]="tipo"></usucampeao-contratos-v2>

    <usucampeao-contratos-v3 *ngSwitchCase="contratoVersao.V3" [cadastro]="cadastro" [proprietario]="proprietario"
      [conjuge]="conjuge" [imovel]="imovel" [tipo]="tipo"></usucampeao-contratos-v3>
  </div>

</ng-container>